import { Alert } from '@restworld/ui-ds-base';
import { CardWrapper } from './card-wrapper';
import { StyledSeparator } from './worker-experiences-section';
import { CertificationSectionItem } from './certification-section-item';
import { useAtomValue } from 'jotai';
import { workerCertificatesAtom } from '../global-state.worker-data';
import { useProfileCommonIntl } from './hooks';

export const CertificationSection = () => {
  const workerCertificates = useAtomValue(workerCertificatesAtom);
  const itemsCount = workerCertificates?.length || 0;
  const { missingInfoText, certificate } = useProfileCommonIntl();
  const { isWorkerCertificationInfoMissing } = useIsWorkerCertificationInfoMissing();

  return (
    <CardWrapper variant="add" title={certificate} editPageType="certifications">
      <div className="flex flex-col items-start pt-4">
        {isWorkerCertificationInfoMissing && <Alert text={missingInfoText} />}
        {workerCertificates?.map((workerCertificate, index) => (
          <div className="w-full" key={index} id={`certifications-${index}`}>
            <CertificationSectionItem key={index} {...{ workerCertificate, workerCertificateIndex: index }} />
            {index < itemsCount - 1 && <StyledSeparator />}
          </div>
        ))}
      </div>
    </CardWrapper>
  );
};

export function useIsWorkerCertificationInfoMissing() {
  const workerCertificates = useAtomValue(workerCertificatesAtom);
  const isWorkerCertificationInfoMissing = !workerCertificates || workerCertificates?.length === 0;

  return { isWorkerCertificationInfoMissing };
}
